import React, { useEffect, useRef, useState } from 'react'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import RatingCard from '../components/RatingCard'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import { ReactSVG } from 'react-svg'
import Btn from '../components/Btn'
import BtnIcon from '../components/BtnIcon'
import Card from '../components/Card'
import Dropdown from '../components/Dropdown'
import Status from '../components/Status'
import { useAxios } from '../hooks/useAxios'
import { getEventParticipation } from '../api/getEventParticipation'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { updateEventApplication } from '../api/updateEventApplication'
import { confirmEventApplications } from '../api/confirmEventApplications'
const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Мероприятия',
    path: '/events'
  }
]
const ParticipantsPage: React.FC = () => {
  const { id } = useParams()
  const [breadcrumbs, setBreadcrumbs] = useState(BREADCRUMBS)
  const [responseData, setResponseData] = React.useState<any>(null)
  const refreshListRef = useRef<null | (() => Promise<any>)>(null)
  const { portal } = usePortal()
  const { fire: participationFire } = useAxios()
  const { fire: fireApplicationItem } = useAxios()
  const { fire: fireApplication } = useAxios()
  useEffect(() => {
    participationFire(getEventParticipation(id)).then(({ response, error }) => {
      if (!error) {
        setResponseData(response?.data ?? null)
        const newBreadCrumbs = [
          ...BREADCRUMBS,
          { label: response?.data?.title, path: response?.data?.id },
          { label: 'Заявки на участие', path: '/participants' }
        ]
        setBreadcrumbs(newBreadCrumbs)
      }
    })
  }, [])
  const handleUpdate = async ( participantId: string, status: string) => {
  const { error } = await fireApplicationItem(
    updateEventApplication( participantId, status)
  )
  if (error) {
    toast.error(error.message)
  } else {
    toast.success('Статус заявки обновлён', { autoClose: 10000 })
    await refreshListRef.current?.()
    participationFire(getEventParticipation(id)).then(({ response, error }) => {
      if (!error) {
        setResponseData(response?.data ?? null)
      }
    })
  }
}
  const handleConfirmAll = async () => {
    const { error } = await fireApplication(
      confirmEventApplications(responseData?.id)
    )
    if (error) {
      toast.error(error.message)
    } else {
      toast.success('Заявки подтверждены', { autoClose: 10000 })
      await refreshListRef.current?.()
      participationFire(getEventParticipation(id)).then(({ response, error }) => {
        if (!error) {
          setResponseData(response?.data ?? null)
        }
      })
    }
  }
  return (
    <div className={'page'}>
      <Breadcrumbs
        className="page__breadcrumbs _participants"
        breadcrumbs={breadcrumbs}
      />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={breadcrumbs} className="_participants" />,
          portal
        )}
      <header className="page__head">
        <h1>Заявки на участие</h1>
        <Btn
          disabled={responseData?.accepted >= responseData?.limit}
          onClick={handleConfirmAll}
        >
          <span>Подтвердить всех</span>
        </Btn>
      </header>
      <div className="page__content">
        <Articles
          queryMode
          noSections
          onSetup={(refresh) => {
            refreshListRef.current = refresh
          }}
          method={(options: any) =>
            getArticles('/participants/list', {
              ...options,
              eventId: id
            })
          }
          renderContent={(data, loading) => {
            return (
              <div className={'participants-applications'}>
                {loading ? (
                  <div>
                    {Array.from({ length: 9 }).map((_, index) => (
                      <Skeleton
                        className={classNames({ 'mt-md-5 mt-sm-4': !!index })}
                        borderRadius={'2.4rem'}
                        key={index}
                        height={'7.2rem'}
                      />
                    ))}
                  </div>
                ) : data.items.length ? (
                  <>
                    {responseData && (
                      <div className={'participants-applications__head'}>
                        <div className={'participants-applications__info'}>
                          <div className={'text-h3'}>
                            Лимит: {responseData?.limit} человек
                          </div>
                          <div className={'text-h3'}>
                            Одобрено:
                            <span
                              style={{
                                color:
                                  responseData?.accepted < responseData?.limit
                                    ? '#6DA800'
                                    : '#FF004E'
                              }}
                            >
                              {responseData?.accepted}/{responseData?.limit}
                            </span>
                          </div>
                        </div>
                        <p className={'text-h4 text-secondary-color'}>
                          Всего заявок: {responseData?.total}
                        </p>
                      </div>
                    )}
                    <div>
                      {data.items.map((item: any, index: number) => {
                        const isPending = item.status === 'pending'
                        const isAccepted = item.status === 'accepted'
                        return (
                          <RatingCard
                            {...item}
                            className={classNames({
                              'mt-md-5 mt-sm-4': !!index
                            })}
                            key={item.id}
                          >
                            {isPending ? (
                              <div className={'rating-card__actions'}>
                                <Btn
                                  outlined
                                  disabled={
                                    responseData?.accepted >= responseData?.limit
                                  }
                                  onClick={() => {
                                    handleUpdate(item.id, 'accepted')
                                  }}
                                >
                                  <span>Подтвердить</span>
                                </Btn>
                                <Btn
                                  outlined
                                  onClick={() => {
                                    handleUpdate(item.id, 'rejected')
                                  }}
                                >
                                  <span>Отклонить</span>
                                </Btn>
                              </div>
                            ) : (
                              <div className={'rating-card__actions'}>
                                <Status
                                  label={
                                    isAccepted ? 'Подтверждено' : 'Отклонено'
                                  }
                                  color={isAccepted ? 'green' : 'red'}
                                  icon={
                                    isAccepted
                                      ? 'check-circle'
                                      : 'alert-circle'
                                  }
                                />
                                <Dropdown
                                  trigger={(open) => {
                                    return (
                                      <BtnIcon onClick={open} filled>
                                        <ReactSVG
                                          wrapper={'span'}
                                          src={'/i/svg/dots-vertical.svg'}
                                        />
                                      </BtnIcon>
                                    )
                                  }}
                                  render={(close) => {
                                    return (
                                      <Card
                                        className={classNames(
                                          'information-item__dropdown-card',
                                          'dropdown-menu'
                                        )}
                                        size={'sm'}
                                      >
                                        <ul>
                                          <li>
                                            {isAccepted ? (
                                              <button
                                                onClick={async () => {
                                                  await close()
                                                  handleUpdate(
                                                    item.id,
                                                    'rejected'
                                                  )
                                                }}
                                                type={'button'}
                                              >
                                                Отклонить
                                              </button>
                                            ) : (
                                              <button
                                                onClick={async () => {
                                                  await close()
                                                  handleUpdate(
                                                    item.id,
                                                    'accepted'
                                                  )
                                                }}
                                                type={'button'}
                                              >
                                                Подтвердить
                                              </button>
                                            )}
                                          </li>
                                        </ul>
                                      </Card>
                                    )
                                  }}
                                />
                              </div>
                            )}
                          </RatingCard>
                        )
                      })}
                    </div>
                  </>
                ) : (
                  'Нет данных'
                )}
              </div>
            )
          }}
        />
      </div>
    </div>
  )
}
export default ParticipantsPage